import { render, staticRenderFns } from "./carousel-main.vue?vue&type=template&id=23a000ce"
import script from "./carousel-main.vue?vue&type=script&lang=js"
export * from "./carousel-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports